"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskPool = exports.TaskQueue = exports.TaskChain = void 0;
var promise_1 = require("../utils/promise");
var TaskChain = /** @class */ (function () {
    function TaskChain() {
        this.promise = (0, promise_1.promiseResolve)();
    }
    TaskChain.prototype.run = function (a) {
        var newPromise = this.promise.then(a);
        this.promise = newPromise;
        return newPromise;
    };
    TaskChain.prototype.wait = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.promise];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return TaskChain;
}());
exports.TaskChain = TaskChain;
var TaskQueue = /** @class */ (function () {
    function TaskQueue() {
        this.promise = (0, promise_1.promiseResolve)();
    }
    TaskQueue.prototype.run = function (a) {
        var queuedPromise = this.promise.then(a);
        this.promise = queuedPromise.then(function (data) { return Promise.resolve(data); }, function () { return null; });
        return queuedPromise;
    };
    TaskQueue.prototype.wait = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.promise];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return TaskQueue;
}());
exports.TaskQueue = TaskQueue;
var TaskPool = /** @class */ (function () {
    function TaskPool(limit) {
        this.queues = [];
        for (var i = 0; i < limit; i++) {
            var queue = new TaskQueue();
            this.queues.push(queue);
        }
    }
    TaskPool.prototype.wait = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, promise_1.promiseAll)(this.queues.map(function (q) { return q.wait(); }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TaskPool.prototype.run = function (action) {
        var _this = this;
        return (0, promise_1.newPromise)(function (resolve, reject) {
            var queued = false;
            _this.queues.forEach(function (queue) {
                return queue.run(function () {
                    if (queued)
                        return;
                    queued = true;
                    try {
                        return action().then(resolve, reject);
                    }
                    catch (e) {
                        reject(e);
                    }
                });
            });
        });
    };
    return TaskPool;
}());
exports.TaskPool = TaskPool;
